import { CompanyThemeEnum } from "#root/config/enums/company-theme.enum";
import { CompanyEnum } from "#root/config/enums/company.enum";
import { FeatureFlagEnum } from "#root/config/enums/feature-flag.enum";
import { LabelEnum } from "#root/config/enums/label.enum";
import { AppEnvConfig } from "#root/config/interfaces/app-config.interface";

export const APP_CONFIG_IP: AppEnvConfig = {
  appName: CompanyEnum.InmobiliariaPlatino,
  theme: CompanyThemeEnum.InmobiliariaPlatino,
  manualUrl:
    "https://platinosoftware.blob.core.windows.net/inmobiliaria/Manual_De_Usuario_Crm_ip.pdf",
  minPasswordSize: 8,

  logoLight:
    "assets/images/companies/inmobiliaria-platino/black_letters_logo.png",
  logoDark:
    "assets/images/companies/inmobiliaria-platino/white_letters_logo.png",
  isotype: "assets/images/companies/inmobiliaria-platino/app_isotype.png",

  labels: [
    {
      key: LabelEnum.EXAMPLE,
      value: "Example Label",
    },
  ],

  featureFlags: [
    {
      key: FeatureFlagEnum.ERP_INTEGRATION,
      enabled: true,
    },
    {
      key: FeatureFlagEnum.MASS_CUSTOMER_CREATION,
      enabled: false,
    },
    {
      key: FeatureFlagEnum.SHOW_METERS_IN_MULTIPLE_QUOTE,
      enabled: false,
    },
    {
      key: FeatureFlagEnum.PRINT_PAYMENT_PLAN,
      enabled: true,
    },
  ],
};
